import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SovosEnterpriseTheme from 's1-ui/themes/sovos-enterprise';
import MuiThemeProviderOld from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import aprTheme from './mainTheme';


class MainThemeProvider extends Component {
  componentDidMount() {
    // Set defaults
    document.body.style.fontFamily = aprTheme.fontFamily;
    document.body.style.color = aprTheme.palette.textColor;
  }

  render() {
    return (
      <MuiThemeProviderOld muiTheme={ getMuiTheme({
        ...SovosEnterpriseTheme,
        ...aprTheme,
        raisedButton: { ...SovosEnterpriseTheme.raisedButton, ...aprTheme.raisedButton},
        flatButton: { ...SovosEnterpriseTheme.flatButton, ...aprTheme.flatButton}
      }) }>
        { this.props.children }
      </MuiThemeProviderOld>
    );
  }
}

MainThemeProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default MainThemeProvider;



// WEBPACK FOOTER //
// ./src/theme/mainThemeProvider.js